import { render, staticRenderFns } from "./TemporarilyBlockPostNL.vue?vue&type=template&id=4f25ce1b&scoped=true&"
import script from "./TemporarilyBlockPostNL.vue?vue&type=script&lang=js&"
export * from "./TemporarilyBlockPostNL.vue?vue&type=script&lang=js&"
import style0 from "./TemporarilyBlockPostNL.vue?vue&type=style&index=0&id=4f25ce1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f25ce1b",
  null
  
)

export default component.exports